import React from 'react';
import mypicture from "../assets/img/img-mobile.jpg";
import { Container, Row, Col } from 'react-bootstrap';
import { Scrollbars } from 'react-custom-scrollbars';
const personal_infos_list_1 = [
    { label: 'first name', value: 'Steve' },
    { label: 'last name', value: 'Milner' },
    { label: 'age', value: '27 years' },
    { label: 'nationality', value: 'tunisian' },
    { label: 'freelance', value: 'available' }
]
const personal_infos_list_2 = [
    { label: 'Address', value: 'Tunis' },
    { label: 'Phone', value: '+21621184010' },
    { label: 'Email', value: 'you@mail.com' },
    { label: 'Skype', value: 'steve.milner' },
    { label: 'Languages', value: 'French, English' }
]
const boxes = [
    { number: '12', label_1: 'Years of ', label_2: 'experience' },
    { number: '97', label_1: 'Completed ', label_2: 'projects' },
    { number: '81', label_1: 'happy ', label_2: 'customers' },
    { number: '53', label_1: 'awards ', label_2: 'won' }
]
const skills = [
    { skill: 'html', value: '25' },
    { skill: 'javascript', value: '89' },
    { skill: 'css', value: '70' },
    { skill: 'php', value: '66' },
    { skill: 'wordpresss', value: '95' },
    { skill: 'jquery', value: '50' },
    { skill: 'angular', value: '65' },
    { skill: 'react', value: '45' }
]
const experience = [
    { period: '2018 - present', position: 'web developer', company: 'envato', description: 'Lorem ipsum dolor sit amet, consectetur tempor incididunt ut labore adipisicing elit, ' },
    { period: '2013 - 2018', position: 'ui/ux designer', company: 'themeforest', description: 'Lorem ipsum dolor sit amet, consectetur tempor incididunt ut labore adipisicing elit, ' },
    { period: '2005 - 2013', position: 'consultant', company: 'videohive', description: 'Lorem ipsum dolor sit amet, consectetur tempor incididunt ut labore adipisicing elit, ' }
]
const education = [
    { period: '2015', diploma: 'engineering degree', university: 'oxford university', description: 'Lorem ipsum dolor sit amet, consectetur tempor incididunt ut labore adipisicing elit, ' },
    { period: '2012', diploma: 'master degree', university: 'kiev university', description: 'Lorem ipsum dolor sit amet, consectetur tempor incididunt ut labore adipisicing elit, ' },
    { period: '2009', diploma: 'bachelor degree', university: 'tunis high school', description: 'Lorem ipsum dolor sit amet, consectetur tempor incididunt ut labore adipisicing elit, ' }
]

class About extends React.Component {
    componentDidMount(){
        document.title = "About Me - Tunis React Personal Portfolio";
        window.scrollTo(0,0);
    }
    render() {
        return (
            <Scrollbars>
                <div className="about">
                    <section
                        className="title-section text-left text-sm-center">
                        <h1>ABOUT <span>ME</span></h1>
                        <span className="title-bg">Resume</span>
                    </section>
                        <section className="main-content">
                        <Container className="container">
                            <Row>
                                <Col lg={5} xl={6}>
                                    <Row>
                                        <Col xs={12}>
                                            <h3 className="text-uppercase custom-title mb-0 ft-wt-600">personal infos</h3>
                                        </Col>
                                        <Col xs={12} className="d-block d-sm-none">
                                            <img src={mypicture} className="img-fluid main-img-mobile" alt="my picture"/>
                                        </Col>
                                        <Col sm={6}>
                                            <ul className="about-list list-unstyled open-sans-font">
                                                {
                                                    Object.keys(personal_infos_list_1).map((item, i) => (
                                                        <li  key={i}>
                                                            <span className="title">{ personal_infos_list_1[item].label } : </span>
                                                            <span
                                                            className="value d-block d-sm-inline-block d-lg-block d-xl-inline-block"> { personal_infos_list_1[item].value }</span>
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </Col>
                                        <Col sm={6}>
                                            <ul className="about-list list-unstyled open-sans-font">
                                                {
                                                    Object.keys(personal_infos_list_2).map((item, j) => (
                                                        <li key={j}>
                                                            <span className="title">{ personal_infos_list_2[item].label } : </span>
                                                            <span
                                                                className="value d-block d-sm-inline-block d-lg-block d-xl-inline-block"> { personal_infos_list_2[item].value }</span>
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </Col>
                                        <Col className="mt-3">
                                            <a href="#" className="btn btn-download"><span>Download CV</span></a>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} lg={7} xl={6} className="mt-5 mt-lg-0">
                                    <Row>
                                        {
                                            Object.keys(boxes).map((item, k) => (
                                            <Col xs={6} key={k}>
                                                <div className="box-stats with-margin">
                                                    <h3 className="poppins-font position-relative">{ boxes[item].number }</h3>
                                                    <p className="open-sans-font m-0 position-relative text-uppercase">{ boxes[item].label_1 } <span
                                                    className="d-block">{ boxes[item].label_2 }</span></p>
                                                </div>
                                            </Col>
                                            ))
                                        }
                                    </Row>
                                </Col>
                            </Row>
                            <hr className="separator" />
                            <Row>
                                <Col xs={12}>
                                    <h3 className="text-uppercase pb-4 pb-sm-5 mb-3 mb-sm-0 text-left text-sm-center custom-title ft-wt-600">My
                                        Skills</h3>
                                </Col>
                                {
                                    Object.keys(skills).map((item, e) => (
                                    <Col xs={6} className="col-md-3 mb-3 mb-sm-5" key={e}>
                                        <div className={`c100 p${skills[item].value}`}>
                                            <span>{ skills[item].value }%</span>
                                            <div className="slice">
                                                <div className="bar"></div>
                                                <div className="fill"></div>
                                            </div>
                                        </div>
                                        <h6 className="text-uppercase open-sans-font text-center mt-2 mt-sm-4">{ skills[item].skill }</h6>
                                    </Col>
                                    ))
                                }
                            </Row>
                            <hr className="separator mt-1" />
                                <Row className="row">
                                    <Col xs={12}>
                                        <h3 className="text-uppercase pb-5 mb-0 text-left text-sm-center custom-title ft-wt-600">Experience <span>&</span> Education
                                        </h3>
                                    </Col>
                                    <Col lg={6} className="m-15px-tb">
                                        <div className="resume-box">
                                            <ul>
                                                {
                                                    Object.keys(experience).map((item, m) => (
                                                    <li key={m}>
                                                    <div className="icon">
                                                        <i className="fa fa-briefcase"></i>
                                                        </div>
                                                        <span className="time open-sans-font text-uppercase">{ experience[item].period }</span>
                                                        <h5 className="poppins-font text-uppercase">{ experience[item].position } <span
                                                        className="place open-sans-font">{ experience[item].company }</span></h5>
                                                        <p className="open-sans-font">{ experience[item].description }</p>
                                                    </li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    </Col>
                                    <Col lg={6} className="m-15px-tb">
                                        <div className="resume-box">
                                            <ul>
                                                {
                                                    Object.keys(education).map((item, n) => (
                                                        <li key={n}>
                                                            <div className="icon">
                                                                <i className="fa fa-briefcase"></i>
                                                            </div>
                                                            <span className="time open-sans-font text-uppercase">{ education[item].period }</span>
                                                            <h5 className="poppins-font text-uppercase">{ education[item].diploma } <span
                                                                className="place open-sans-font">{ education[item].university }</span></h5>
                                                            <p className="open-sans-font">{ education[item].description }</p>
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    </Col>
                                </Row>
                        </Container>
                    </section>
                </div>
            </Scrollbars>
        )
    }
}

export default About